import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
export const ContentAnimationWrapper = ({ durationAndDelay = 0.25, animation = 'enter', children, }) => {
    const transition = {
        duration: durationAndDelay,
        ease: [0.4, 0.0, 0.5, 1],
        delay: durationAndDelay,
    };
    const variants = {
        hidden: {
            opacity: 0,
            height: 0,
            y: -50,
            transition,
            transitionEnd: {
                display: 'none',
            },
        },
        visible: {
            opacity: 1,
            height: 'auto',
            y: 0,
            transition,
            display: 'block',
        },
    };
    return (
    // transition must be placed inside both, visible and hidden.
    // if we put it into <motion.div transition={...}> instead, the display: 'none' behaves buggy.
    // visible -> hidden: the display is none
    // visible -> hidden -> visible -> hidden: the display is wrongly 'block'
    React.createElement(motion.div, { initial: animation === 'visible' ? 'visible' : 'hidden', animate: animation === 'hidden' ? 'hidden' : 'visible', variants: variants }, children));
};
ContentAnimationWrapper.propTypes = {
    children: PropTypes.object.isRequired,
};
